import Select from 'components/Formik/Select';

const ProductsOfInterest = ({ initialValues, data }) => {
    initialValues.Product_s_of_Interest__c = [];

    const { label, options, placeholder } = data;
    return (
        <Select
            options={options}
            label={label}
            isMulti
            placeholder={placeholder}
            name="Product_s_of_Interest__c"
        />
    );
};

export default ProductsOfInterest;
